import { Check } from '@mui/icons-material';
import { ListItemText, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import { getCookie, setCookie } from '../../hooks/useCookie';

const DropDownMenu = ({
  numbers,
  setSubscriptionId,
  subscriptionId,
  openAbondonModal,
  clearJourney,
  setChangeSubs,
  setClearJourney,
  additionalStyles,
}) => {
  const theme = useTheme();
  const [selectedNumber, setSelectedNumber] = useState('Choose an address');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState([]);

  const handleSelectChange = event => {
    const number = event?.target?.value;
    // setSelectedSub([...selectedSub, number]);
    setSelectedSub([number]);
    setChangeSubs(true);
    // setSelectedNumber(number);
    setSubscriptionId(number);
    setClearJourney(false);
  };

  useEffect(() => {
    if (selectedSub.length > 1) {
      openAbondonModal.enable();
    }
  }, [selectedSub]);
  useEffect(() => {
    if (clearJourney === true) {
      setSelectedNumber('Choose an address');
      setSelectedSub([]);
    }
  }, [clearJourney]);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (subscriptionId) {
      const data = numbers.find(item => item.value === parseInt(subscriptionId, 10));
      setCookie('ION', 'ECC_ADDRESS', data?.addressInfo);
      setSelectedNumber(data?.addressInfo || getCookie('SUBSCRIPTION_ID'));
    }
  }, [subscriptionId, numbers]);
  return (
    <Select
      value={selectedNumber}
      onChange={handleSelectChange}
      onOpen={handleOpen}
      onClose={handleClose}
      open={isOpen}
      renderValue={selected => selected}
      MenuProps={{
        PaperProps: {
          sx: {
            // backgroundColor: '#C4C4C4',
            borderRadius: '10px',
            marginTop: '4px',
            boxShadow: '0px 2px 4px -1px #D0D0D0, 0px 4px 5px #D0D0D0, 0px 1px 10px #D0D0D0',
          },
        },
      }}
      sx={additionalStyles ? styles(theme).container : styles(theme).selectContainer}
    >
      {numbers.map(number => (
        <MenuItem
          key={number.value}
          value={number.value}
          onClick={number.onClick}
          // disabled={number.changeOffer && number.totalAmountVatIncluded === 0 ? false : true}
          disabled={!number.changeOffer}
          sx={styles(theme).menuItems}
        >
          <ListItemText primary={number.addressInfo} />
          {isOpen && selectedNumber === number.value && <Check sx={{ color: 'green' }} />}
        </MenuItem>
      ))}
      <MenuItem value='Choose an address'>
        <Typography variant='body1' sx={styles(theme).defaultMenuItem}>
          Choose an address
        </Typography>
      </MenuItem>
    </Select>
  );
};

export default DropDownMenu;
